// 封装全局方法，将文本域更改为富文本编辑器格式
const getEditorText = (text) => {
    let textMsg
    if (text) {
        textMsg = text.replace(/<\/p>/g, '\n')
        textMsg = textMsg.replace(/<p>/g, '')
        textMsg = textMsg.substring(0, textMsg.length - 1)
    } else {
        textMsg = ""
    }
    return textMsg
}

export default getEditorText